<template>
  <div id="login" class="login-background-color">
    <img src="@/assets/logo.png" style="height: 250px; margin: 50px;" />
    <div>
      <p>Philips Care Portal</p>
    </div>
    <section style="width: 500px; margin: auto;">
      <div v-if="view == 'login'" class="login_contents" style="margin: auto;">
        <b-field
          :type="{ 'is-danger': errors.has('mailAddress') }"
          :message="errors.first('mailAddress')"
          style="
            color: whitesmoke;
            border: none;
            border-radius: 0px;
            box-shadow: none;
            outline: none;
          "
        >
          <b-input
            name="mailAddress"
            data-vv-as="メールアドレス"
            type="text"
            v-model="mailAddress"
            v-validate="'required|email2|max:100'"
            placeholder="メールアドレスを入力してください"
            maxlength="100"
            @keydown.enter.native="loginAreaEnter"
          ></b-input>
        </b-field>
        <b-field
          :type="{ 'is-danger': errors.has('password') }"
          :message="errors.first('password')"
        >
          <b-input
            name="password"
            data-vv-as="パスワード"
            type="password"
            v-model="password"
            password-reveal
            placeholder="パスワードを入力してください"
            v-validate="'required'"
            maxlength="100"
            @keydown.enter.native="loginAreaEnter"
          ></b-input>
        </b-field>
      </div>
      <div v-if="view == 'passPhrase'" class="login_contents">
        <div class="passphrase_txt">
          <span>
            登録済みの電話番号またはメールアドレスにパスフレーズを送信しました。
            受信したパスフレーズを入力して、ログインしてください。
          </span>
        </div>
        <b-field
          label="パスフレーズ"
          :type="{ 'is-danger': errors.has('passPhrase') }"
          :message="errors.first('passPhrase')"
        >
          <b-input
            name="passPhrase"
            data-vv-as="パスフレーズ"
            type="text"
            password-reveal
            v-model="passPhrase"
            placeholder="パスフレーズを入力してください"
            maxlength="100"
            @keydown.enter.native="passPhraseAreaEnter"
          ></b-input>
        </b-field>
      </div>
    </section>
    <footer class="login-footer">
      <div v-if="view == 'login'">
        <b-button
          class="button is-primary is-inverted"
          type="button"
          :disabled="!isActive"
          v-on:click="login"
          style="
            width: 500px;
            margin: 0 0 5px 0;
            background-color: #00325d;
            color: whitesmoke;
          "
          >ログイン</b-button
        >
        <b-button
          class="button"
          :disabled="!isActive"
          v-on:click="passwordInit"
          style="
            width: 500px;
            background: transparent;
            border: none;
            color: whitesmoke;
          "
          >パスワード初期化</b-button
        >
      </div>
      <div v-if="view == 'passPhrase'">
        <b-button
          class="button is-primary is-inverted has-text-centered"
          icon-left="login"
          type="button"
          :disabled="!isActive"
          v-on:click="comfirmPassPhrase"
          style="width: 100px"
          >確認</b-button
        >
        <b-button
          class="button is-primary is-inverted has-text-centered"
          icon-left="login"
          type="button"
          :disabled="!isActive"
          v-on:click="back"
          style="width: 100px"
          >戻る</b-button
        >
      </div>
      <div class="is-inverted" style="color: white; margin: 0 0 0 auto">
        Ver.{{ version }}
        <br>
        更新日：{{ dateUpdated }}
      </div>
    </footer>
    <div style="height: 30px" />
    <div class="modal-card" style="width: 500px">
      <div class="field is-floating-label" style="margin-top: 10px">
        <label class="label">Philipsからのお知らせ</label>
        <b-input
          :value="notice"
          type="textarea"
          style="height: auto"
          readonly
        ></b-input>
      </div>
    </div>
    <div style="height: 50px" />
    <div>
      <ul>
        <li>
          <a
            href="mailto:SRC_kensa_Inquiry@philips.com"
            style="color: whitesmoke"
            >お問い合わせ</a
          >
        </li>
        <li>
          <a
            href="https://www.philips.co.jp/a-w/privacy-notice.html"
            target="_blank"
            rel="noopener noreferrer"
            style="color: whitesmoke"
            >プライバシーに関する通知</a
          >
        </li>
        <li>
          <a
            href="https://www.philips.co.jp/a-w/about-philips/company/local-personal-information"
            target="_blank"
            rel="noopener noreferrer"
            style="color: whitesmoke"
            >個人情報取扱方針</a
          >
        </li>
      </ul>
    </div>
    <div style="height: 20px;" />
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
export default {
  name: "login",
  data() {
    var env = this.$store.state.env;
    var version = this.$store.state.version;
    var dateUpdated = this.$store.state.dateUpdated;
    return {
      env: env,
      role: role,
      mailAddress: "",
      password: "",
      passPhrase: "",
      isActive: true,
      version,
      dateUpdated,
      view: "login",
      notice: "",
      userInfo: null,
      passPhraseErrorCount: 0,
      introductionQuery:
        this.$route.query && this.$route.query.query
          ? this.$route.query.query
          : "",
      introductionKey:
        this.$route.query && this.$route.query.key
          ? this.$route.query.key
          : "",
      introductionName:
        this.$route.name
          ? this.$route.name
          : "",
      reqData: "",
      reqMailKey: "",
      reqMailAddress: "",
      decKeyErrMessage: "",
      alertMessage: "",
      apiReqFlg:false,
      introductionDLFlg:false,
      introductionRequestFlg:false
    };
  },
  methods: {
    login: function () {
      this.isActive = false;
      console.log("login called.");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("login", {
              mail: this.mailAddress,
              password: this.password,
            })
            .then((result) => {
              console.log(result);
              if (result != null && result.status === 200) {
                this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                //パスフレーズ認証
                let passphraseFlag = this.userInfo.passphraseFlag;
                if (passphraseFlag) {
                  this.isActive = true;
                  this.view = "passPhrase";
                } else {
                  this.goToMenu();
                }
              } else if (
                result != null &&
                (result.status === 400 ||
                  result.status === 401 ||
                  result.status === 500)
              ) {
                var message = "予期しないエラーが発生しました。";
                if (result.response.body) {
                  message = result.response.body.message;
                } else if (result.message) {
                  message = result.message;
                }

                if (message === "内部ユーザはSSO認証ログイン画面よりログインしてください。"){
                  new Promise(resolve => {
                    this.$store._vm.$dialog.confirm({
                      title: '　',
                      message: "<p>内部ユーザのログインURLが新しくなりました。</p>" 
                             + "<p>下の「SSO認証」ボタンから、<br>SSOログイン画面へ進んでください。</p>"
                             + "<p class='sso-message-background-color'>新しいURLをブックマークしていただくようお願いします</p>",
                      canCancel: false,
                      confirmText: 'SSO認証',
                      onConfirm: () => {  
                        window.location.href = this.$store.state.ssoLogin
                      },
                    });
                  });
                } else {
                  this.showErrorMessage(message);
                }
                this.isActive = true;
              } else {
                this.isActive = true;
                this.showErrorMessage("予期しないエラーが発生しました。");
              }
            })
            .catch((error) => {
              this.isActive = true;
            });
        } else {
          this.isActive = true;
        }
      });
    },
    loginAreaEnter: function() {
      if(this.mailAddress && this.password){
        this.login();
      }
    },
    passwordInit: function (event) {
      console.log("passwordInit called.");
      this.$router.push(this.createPwdInitParam());
    },
    comfirmPassPhrase: function () {
      //パスフレーズ認証
      this.isActive = false;
      console.log("comfirmPassPhrase called.");
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store
            .dispatch("authPassPhrase", {
              mail: this.mailAddress,
              passPhrase: this.passPhrase,
            })
            .then((result) => {
              console.log(result);
              if (result != null && result.status === 200) {
                //OKだったらメニューへ遷移
                this.goToMenu();
              } else if (result != null && result.status === 401) {
                //認証失敗
                if (this.passPhraseErrorCount > 4) {
                  //メッセージ（5回失敗しました。再度ログイン画面に戻ります。）
                  this.showErrorMessage(
                    "試行回数が制限に達しました。ログイン画面に戻ります。"
                  );
                  this.passPhraseErrorCount = 0;
                  this.view = "login";
                } else {
                  //メッセージ（パスフレーズが違います）
                  this.showErrorMessage("パスフレーズが違います。");
                  this.passPhraseErrorCount += 1;
                }
                this.isActive = true;
              } else {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。");
                this.isActive = true;
              }
            })
            .catch((error) => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。");
              this.isActive = true;
            });
        } else {
          this.isActive = true;
        }
      });
    },
    passPhraseAreaEnter: function() {
      if(this.passPhrase){
          this.comfirmPassPhrase();
      }
    },
    back: function (event) {
      this.password = "";
      this.view = "login";
    },
    goToMenu: async function () {
      var internalUserHomePath = "/philips/home";
      var externalUserHomePath = "/guest/home";
      if (this.userInfo.passwordForceChange) {
        //パスワード強制変更画面
        this.$router.push(this.createPasswordForceChangeParam());
      } else {
        let roleId = this.userInfo.roleId;
        if (this.introductionQuery || this.introductionKey) {
          // メールURL遷移
          // 認証後、表示するデータがあるか確認
          if (this.introductionName == "requestViewer") {
            //requestViewer
            await this.$store.dispatch("requestViewerAuth", {
              key: this.introductionKey,
              password: ""
            }).then(result => {
              if (result != null && result.status === 200 ) {
                this.reqData = result;
                this.apiReqFlg = true;
                this.alertMessage ="";
              } else if (result.status === 500) {
                //システムエラーが発生しました。
                this.decKeyErrMessage = result.response.obj.message;
              } else if (result.status === 402) {
                //対象の申込みはキャンセルされています。
                this.alertMessage = result.response.obj.message;
              }else{
                this.decKeyErrMessage ="システムエラーが発生しました。";
              }
            }).catch(error => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。")
            });
          } else if (this.introductionName == "reExaminationAdjustment") {
            // reExaminationAdjustment
            let shortestShippingDateList = this.getShortestShippingDate();
            await this.$store.dispatch("requestReExaminationAdjustment", {
              key: this.introductionKey,
              shortestShippingDateList: shortestShippingDateList,
              selectType: "",
            }).then(result => {
              if (result != null && result.status === 200 ) {
                this.reqData = result;
                this.apiReqFlg = true;
              } else if (result.status === 500) {
                //システムエラーが発生しました。
                this.decKeyErrMessage = result.response.obj.message;
              } else if (result.status === 402) {
                //対象の申込みはキャンセルされています。
                this.alertMessage = result.response.obj.message;
              }else{
                this.decKeyErrMessage ="システムエラーが発生しました。";
              }
            }).catch(error => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。")
            });
          } else if (this.introductionName == "ResultDownload") {
            //ResultDownload
            await this.$store.dispatch("resultDownload", {
              key: this.introductionQuery,
              password: ""
            }).then(result => {
              if (result != null && result.status === 200 ) {
                this.reqData = result;
                this.apiReqFlg = true;
              } else if (result.status === 500) {
                //システムエラーが発生しました。
                this.decKeyErrMessage = result.response.obj.message;
              } else if (result.status === 402) {
                //対象の申込みはキャンセルされています。
                this.alertMessage = result.response.obj.message;
              }else{
                this.decKeyErrMessage ="システムエラーが発生しました。";
              }
            }).catch(error => {
              console.log(error);
              this.showErrorMessage("予期しないエラーが発生しました。")
            });
          }else if (this.introductionName == "HolterPatientReportRedirect") {
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
              await this.$store
              .dispatch("verifyKeyForHolterPatientReportRedirect", {
                query: this.introductionQuery,
                token: userInfo.token,
              })
              .then((result) => {

                if (result != null && result.status === 200) {
                  //転院紹介申込サイト転院先検証_正常終了
                  this.apiReqFlg = true;
                  if(result.body.receptionNo){
                    this.goToRequestFormList(
                      result.body.receptionNo
                    );
                  }
                } else if (result != null && result.status === 400) {
                  //ユーザ不一致の場合、データなしの場合
                  this.isActive = true;
                  this.apiReqFlg = true;
                } else if (result.status === 500) {
                  //システムエラーが発生しました。
                  this.isActive = true;
                  this.decKeyErrMessage = result.response.obj.message;
                } else if (result.status === 402) {
                  //対象の申込みはキャンセルされています。
                  this.isActive = true;
                  this.alertMessage = result.response.obj.message;
                } else {
                  this.isActive = true;
                  this.decKeyErrMessage ="システムエラーが発生しました。";
                }
              });






          } else {
            //転院紹介
            if (
              roleId == this.role.role_admin ||
              roleId == this.role.role_headOffice ||
              roleId == this.role.role_headOffice_sales ||
              roleId == this.role.role_headOffice_division ||
              roleId == this.role.role_headOffice_sw ||
              roleId == this.role.role_salesOffice ||
              roleId == this.role.role_psc ||
              roleId == this.role.role_kawagoe ||
              roleId == this.role.role_kawagoe_cpap ||
              roleId == this.role.role_call_center ||
              roleId == this.role.role_headOffice_call ||
              roleId == this.role.role_ndss
            ) {
              //内部ユーザー
              //転院紹介の場合、ログイン成功時点で正常終了させる
              this.apiReqFlg = true;
            } else {
              //外部ユーザー
              this.isActive = false;
              var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
              await this.$store
              .dispatch("verifyKeyForIntroductionRequestAuth", {
                query: this.introductionQuery,
                token: userInfo.token,
              })
              .then((result) => {
                if (result != null && result.status === 200) {
                  //転院紹介申込サイト転院先検証_正常終了
                  this.apiReqFlg = true;
                  if (result.body.resultDownload) {
                    //DLデータ取得
                    this.introductionDLFlg = true;
                    this.goToResultDownload(result.body.resultDownload);
                  } else {
                    //申込み画面に遷移
                    this.introductionRequestFlg = true;
                    this.goToRequest(
                      result.body.prekind,
                      result.body.serviceId,
                      result.body.receptionNo
                    );
                  }
                } else if (result != null && result.status === 400) {
                  //ユーザ不一致の場合、データなしの場合
                  this.isActive = true;
                  this.apiReqFlg = true;
                } else if (result.status === 500) {
                  //システムエラーが発生しました。
                  this.isActive = true;
                  this.decKeyErrMessage = result.response.obj.message;
                } else if (result.status === 402) {
                  //対象の申込みはキャンセルされています。
                  this.isActive = true;
                  this.alertMessage = result.response.obj.message;
                } else {
                  this.isActive = true;
                  this.decKeyErrMessage ="システムエラーが発生しました。";
                }
              });
            }
          }
          // 認証ユーザー確認
          // リクエストに含まれる登録用キーよりメールアドレスを取得
          this.reqMailKey = this.introductionKey ? this.introductionKey : this.introductionQuery;
          await this.$store.dispatch("verifyKey", {
            key: this.reqMailKey
          }).then(result => {
            if(result != null && result.status === 200 ) {
              this.reqMailAddress = result.obj.mail;
            }
          }).catch(error => {
            this.showErrorMessage(result);
          });
          if (this.reqData && this.reqMailAddress && this.reqMailAddress.includes(this.mailAddress)) {
            // 表示データがあるかつ、メール送信先のアドレスと個人認証で入力したアドレスが同じ場合
            this.$emit('close-login', this.reqData);
          } else if ((this.introductionDLFlg || this.introductionRequestFlg) && this.reqMailAddress && this.reqMailAddress.includes(this.mailAddress)) {
            //(施設紹介DLまたは施設紹介_申込み)正常終了
            return;
          } else {
            if (
              roleId == this.role.role_admin ||
              roleId == this.role.role_headOffice ||
              roleId == this.role.role_headOffice_sales ||
              roleId == this.role.role_headOffice_division ||
              roleId == this.role.role_headOffice_sw ||
              roleId == this.role.role_salesOffice ||
              roleId == this.role.role_psc ||
              roleId == this.role.role_kawagoe ||
              roleId == this.role.role_kawagoe_cpap ||
              roleId == this.role.role_call_center ||
              roleId == this.role.role_headOffice_call ||
              roleId == this.role.role_ndss
            ) {
              //内部ユーザー
              if (this.decKeyErrMessage) {
                // 暗号解読エラー
                this.$router.push({ path: internalUserHomePath });
                this.showErrorMessage(this.decKeyErrMessage);
              } else if (this.apiReqFlg == false) {
                // 表示データなし
                this.$router.push({ path: internalUserHomePath });
                this.showErrorMessage(this.alertMessage);
              } else {
                this.$router.push({ path: internalUserHomePath });
              }
            } else {
              //外部ユーザー
              var defUserMessage = "情報セキュリティ対策により参照ユーザーを限定しているため、対象の申込みはご覧いただけません。";
              if (this.apiReqFlg == true && (!this.reqMailAddress.includes(this.mailAddress))) {
                // 表示データありでユーザー不一致
                this.alertMessage = defUserMessage;
              } else {
                // 表示データなし
                if (this.decKeyErrMessage) {
                  // 暗号解読エラー
                  if (this.reqMailAddress && !this.reqMailAddress.includes(this.mailAddress)) {
                    // 参照不可のユーザー
                    this.alertMessage = this.decKeyErrMessage + "<br>" + defUserMessage;
                  } else {
                    this.alertMessage = this.decKeyErrMessage;
                  }
                } else {
                  if (this.reqMailAddress && !this.reqMailAddress.includes(this.mailAddress)) {
                    // 参照不可のユーザー
                    this.alertMessage = this.alertMessage + "<br>" + defUserMessage;
                  } else {
                    this.alertMessage = this.alertMessage;
                  }
                }
              }
              this.$router.push({ path: externalUserHomePath });
              this.showErrorMessage(this.alertMessage);
            }
          }
        } else {
          // 通常ログイン
        if (
          roleId == this.role.role_admin ||
          roleId == this.role.role_headOffice ||
          roleId == this.role.role_headOffice_sales ||
          roleId == this.role.role_headOffice_division ||
          roleId == this.role.role_headOffice_sw ||
          roleId == this.role.role_salesOffice ||
          roleId == this.role.role_psc ||
          roleId == this.role.role_kawagoe ||
          roleId == this.role.role_kawagoe_cpap ||
          roleId == this.role.role_call_center ||
          roleId == this.role.role_headOffice_call ||
          roleId == this.role.role_ndss
        ) {
          //内部ユーザー
          this.$router.push({ path: internalUserHomePath });
        } else {
          //外部ユーザー
          this.$router.push({ path: externalUserHomePath });
        }
        }
      }
    },
    createPasswordForceChangeParam: function () {
      var res = {
        name: "AppPasswordForceChange",
        params: {
          isInitialPassword: this.userInfo.initialPassword,
          currentpassword: this.password,
        },
      };
      if (this.introductionQuery) {
        res.query = {
          query: this.introductionQuery,
        };
      }
      return res;
    },
    createPwdInitParam: function () {
      var res = {
        path: "/pwdInit",
      };
      if (this.introductionQuery) {
        res.query = {
          query: this.introductionQuery,
        };
      }
      return res;
    },
    goToRequest: async function (prekind, serviceId, receptionNo) {
      var loadMasterList = [];
      loadMasterList.push(this.getOfficeMaster())
      loadMasterList.push(this.getStatusMaster())
      loadMasterList.push(this.getAuthMaster())
      loadMasterList.push(this.getKindMaster())
      loadMasterList.push(this.getChoiceMaster())
      loadMasterList.push(this.getCpapChoiceMaster())

      var userInfo = this.getUserInfo();
      if (this.isEnableService(userInfo.useServiceId, service.cpap)) {
        loadMasterList.push(this.getPrescriptionHardware())
        loadMasterList.push(this.getCpapStatusMaster())
        loadMasterList.push(this.getCpapCommonMaster())
        loadMasterList.push(this.getCpapItemMaster())
      }

      var appVue = this.$root.$children[0]
      appVue.loadingStart()

      await Promise.all (loadMasterList)
      .then ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み 正常終了");
      })
      .catch ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み エラー終了\nerrorlog : " + response.message);
      });

      this.$router.push({
        name: this.getRequestComponent(serviceId),
        params: {
          kind: prekind,
          receiptNumber: receptionNo,
          id: prekind == "holder" ? "easy" : "full", // PSG解析
          introduction: true
        },
      });
      return;
    },
    goToResultDownload: function (result) {
      this.$router.push({
        name: "ResultDownload",
        params: {
          result: result,
          name: this.introductionName,
        },
        query: {
          query: this.introductionQuery,
        },
      });
      return;
    },
    goToRequestFormList: async function (receptionNo) {
      var loadMasterList = [];
      loadMasterList.push(this.getOfficeMaster())
      loadMasterList.push(this.getStatusMaster())
      loadMasterList.push(this.getAuthMaster())
      loadMasterList.push(this.getKindMaster())
      loadMasterList.push(this.getChoiceMaster())
      loadMasterList.push(this.getCpapChoiceMaster())

      var userInfo = this.getUserInfo();
      if (this.isEnableService(userInfo.useServiceId, service.cpap)) {
        loadMasterList.push(this.getPrescriptionHardware())
        loadMasterList.push(this.getCpapStatusMaster())
        loadMasterList.push(this.getCpapCommonMaster())
        loadMasterList.push(this.getCpapItemMaster())
      }

      var appVue = this.$root.$children[0]
      appVue.loadingStart()

      await Promise.all (loadMasterList)
      .then ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み 正常終了");
      })
      .catch ((response) => {
        appVue.loadingEnd();
        console.log("マスター読み込み エラー終了\nerrorlog : " + response.message);
      });

      this.$router.push({
        name: "RequestFormList",
        params: {
          tempSearchReceptionNo: receptionNo,
          isFromHolterPatientReportRedirect: true,
        },
      });
      return;
    },
  },
  computed: {},
  mounted: function () {
    this.$store
      .dispatch("getAnnouncement", {
        type: 0,
      })
      .then((result) => {
        console.log(result);
        if (result != null && result.status === 200) {
          this.notice = result.body.contents;
        } else if (result != null && result.status === 401) {
          this.notice = "お知らせを取得できませんでした。";
        } else {
          this.notice = "お知らせを取得できませんでした。";
        }
      })
      .catch((error) => {
        this.notice = "お知らせを取得できませんでした。";
      });
  },
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
.passphrase_txt {
  margin-left: 30px;
  margin-bottom: 32px;
  text-align: left;
}
.modal-card-head,
.modal-card-foot {
  background: linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
    -35deg,
    rgb(0, 114, 218) 0%,
    rgb(110, 173, 243) 100%
  );
}
.modal-card-title {
  color: whitesmoke;
}

ul {
  text-align: center;
  margin-left: -10px;
  font-size: 0; /* タグ改行時の空白防止 */
}

ul li {
  display: inline-block;
  margin-left: 30px;
  font-size: 14px; /* ulでサイズ0にしたのを戻す */
}
.modal-card-title {
  font-size: 1.4rem;
}
.copyright_area {
  margin-top: 10px;
}
.copyright {
  font-size: small;
}
.login-background-color {
  background: -moz-radial-gradient(#0077cd 20%, #00325d 85%);
  background: -webkit-radial-gradient(#0077cd 20%, #00325d 85%);
  background: radial-gradient(#0077cd 20%, #00325d 85%);
  min-height: 100vh;
  height: auto;
  width: 100%;
  padding-bottom: 50px;
}
.login-background-color > div {
  margin: auto;
}
.login-background-color > div > p {
  color: whitesmoke;
  font-size: 35px;
  margin: 0 0 40px 0;
}
.login-footer {
  margin: 50px 0 0 0;
  width: 500px;
  display: inline-block;
}
</style>

<style>
.sso-message-background-color {
  background-color: #FFE5B4;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/login.vue